import ApiService from "../api.service"

const DocumentControlService = {
  Get(id) {
    if (id == 0) {
      return ApiService.get(`/documentcontrol/Get`)
    } else {
      return ApiService.get(`/documentcontrol/Get/${id}`)
    }
  },
  GetList({ filters, ...params }) {
    return ApiService.get2(`/documentcontrol/GetList`, params)
  },
  Create(data) {
    return ApiService.post("/documentcontrol/Create", data)
  },
  Update(data) {
    if (data.id && data.id > 0) {
      return ApiService.post("/documentcontrol/Update", data)
    } else {
      return ApiService.post("/documentcontrol/Create", data)
    }
  },
  Check(
    dbSettlementAccountId,
    ctSettlementAccountId,
    amount,
    paymentSymbolId,
    paymentSymbolPurposeId,
  ) {
    if (paymentSymbolId == null || paymentSymbolId == undefined) {
      paymentSymbolId = ""
    }
    if (paymentSymbolPurposeId == null || paymentSymbolPurposeId == undefined) {
      paymentSymbolPurposeId = ""
    }
    return ApiService.get(
      `/documentcontrol/Check?dbSettlementAccountId=${dbSettlementAccountId}&ctSettlementAccountId=${ctSettlementAccountId}&amount=${amount}&paymentSymbolId=${paymentSymbolId}&paymentSymbolPurposeId=${paymentSymbolPurposeId}`,
    )
  },
  Delete(id) {
    return ApiService.post(`/documentcontrol/Delete/${id}`)
  },
}
export default DocumentControlService
